export const getValue = <T>(value: T | null | undefined, defaultValue: T): T => value || defaultValue;
